// import Swiper from 'swiper';
import Swiper, {Autoplay, EffectCoverflow, EffectCreative, Navigation, Pagination, Scrollbar} from 'swiper';
import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';

class SwiperSlider {
	constructor() {
		this.swiperSliders = document.querySelectorAll('.swiper-slider .swiper');
		this.swiperSlidersResponsive = document.querySelectorAll('.swiper-slider-responsive .swiper');

		this.events();
	}

	events() {
		if (this.swiperSliders) {
			this.swiperSliders.forEach((slider) => {
				this.swiperSlider(slider);
			})
		}
		if (this.swiperSlidersResponsive) {
			this.swiperSlidersResponsive.forEach((slider) => {
				this.swiperSliderResponsive(slider);
			})
		}
	}

	swiperSlider(slider) {
		const speed = parseInt(slider.getAttribute('data-speed'));
		const delay = parseInt(slider.getAttribute('data-delay'));

		const swiper = new Swiper(slider, {
			modules: [Autoplay, EffectCoverflow, EffectCreative, Navigation, Pagination, Scrollbar],

			slidesPerView: 1,
			loop: true,

			speed: speed,
			spaceBetween: 0,
			centeredSlides: true,
			keyboard: true,
			mousewheel: false,

			autoplay: {
				delay: delay,
				disableOnInteraction: false,
				pauseOnMouseEnter: true,
			},

			effect: 'slide', // 'slide' | 'coverflow' | 'creative'
			coverflowEffect: {
				rotate: 30,
				slideShadows: false,
			},
			creativeEffect: {
				prev: {
					translate: [0, 0, -400],
				},
				next: {
					translate: ['100%', 0, 0],
				},
			},

			pagination: {
				el: '.swiper-pagination',
				type: 'bullets', // 'bullets' | 'fraction' | 'progressbar' | 'custom'
				clickable: true,
			},

			navigation: {
				prevEl: '.swiper-button-prev',
				nextEl: '.swiper-button-next',
			},

			scrollbar: {
				el: '.swiper-scrollbar',
				draggable: true,
			},
		});
	}

	swiperSliderResponsive(slider) {
		const speed = parseInt(slider.getAttribute('data-speed'));
		const delay = parseInt(slider.getAttribute('data-delay'));

		const swiper = new Swiper(slider, {
			modules: [Autoplay, EffectCoverflow, EffectCreative, Navigation, Pagination, Scrollbar],

			slidesPerView: 1,
			loop: true,

			speed: speed,
			spaceBetween: 10,
			centeredSlides: false,
			keyboard: true,
			mousewheel: false,

			autoplay: {
				delay: delay,
				disableOnInteraction: false,
				pauseOnMouseEnter: true,
			},

			effect: 'slide', // 'slide' | 'coverflow' | 'creative'
			coverflowEffect: {
				rotate: 30,
				slideShadows: false,
			},
			creativeEffect: {
				prev: {
					translate: [0, 0, -400],
				},
				next: {
					translate: ['100%', 0, 0],
				},
			},

			pagination: {
				el: '.swiper-pagination',
				type: 'bullets', // 'bullets' | 'fraction' | 'progressbar' | 'custom'
				clickable: true,
			},

			navigation: {
				prevEl: '.swiper-button-prev',
				nextEl: '.swiper-button-next',
			},

			scrollbar: {
				el: '.swiper-scrollbar',
				draggable: true,
			},

			breakpoints: {
				// when window width is >= ...px
				750: {
					slidesPerView: 2,
					// spaceBetween: 20
				},
				// when window width is >= ...px
				1000: {
					slidesPerView: 3,
					// spaceBetween: 30
				},
				// when window width is >= ...px
				1200: {
					slidesPerView: 4,
					// spaceBetween: 40
				}
			}
		});
	}
}

new SwiperSlider();
